import { ArrowDown, ArrowUp, Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

export function ComparisonEditor({ content, onChange }) {
  const cmp = { enabled: true, rows: [], ...(content.comparison || {}) };
  const pkgs = content.packages || [];
  const set = (next) => onChange({ ...content, comparison: { ...cmp, ...next } });
  const setRow = (i, patch) => set({ rows: cmp.rows.map((r, j) => (j === i ? { ...r, ...patch } : r)) });
  const setVal = (i, id, v) => setRow(i, { values: { ...(cmp.rows[i].values || {}), [id]: v } });
  const move = (i, d) => {
    const rows = [...cmp.rows];
    const j = i + d;
    if (j < 0 || j >= rows.length) return;
    [rows[i], rows[j]] = [rows[j], rows[i]];
    set({ rows });
  };
  return (
    <div data-testid="comparison-editor" className="bg-card border border-border rounded-2xl p-6 space-y-4">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h3 className="font-display font-bold text-lg">Tabela porównawcza pakietów</h3>
          <p className="text-xs text-muted-foreground mt-1">
            Wyświetlana pod kartami cennika. W komórce wpisz <code className="font-mono">yes</code> (ptaszek), <code className="font-mono">no</code> lub puste (kreska) albo dowolny tekst z limitem, np. „30 stron / mies.”. Tekst zaczynający się od <code className="font-mono">!</code> jest wyróżniony (np. „!bez limitu”).
          </p>
        </div>
        <label className="inline-flex items-center gap-2 text-xs font-semibold shrink-0">
          <Switch data-testid="comparison-enabled" checked={cmp.enabled !== false} onCheckedChange={(v) => set({ enabled: v })} />
          {cmp.enabled !== false ? "Widoczna" : "Ukryta"}
        </label>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="text-xs text-muted-foreground">
              <th className="text-left font-semibold pb-2 pr-2 w-[30%]">Cecha</th>
              {pkgs.map((p) => <th key={p.id} className="text-left font-semibold pb-2 pr-2">{p.name}</th>)}
              <th className="w-24" />
            </tr>
          </thead>
          <tbody>
            {cmp.rows.map((r, i) => (
              <tr key={i} className="align-top">
                <td className="pr-2 pb-2"><Input data-testid={`comparison-row-label-${i}`} value={r.label} onChange={(e) => setRow(i, { label: e.target.value })} /></td>
                {pkgs.map((p) => (
                  <td key={p.id} className="pr-2 pb-2"><Input data-testid={`comparison-row-${i}-${p.id}`} value={r.values?.[p.id] || ""} placeholder="yes / no / tekst" onChange={(e) => setVal(i, p.id, e.target.value)} /></td>
                ))}
                <td className="pb-2">
                  <div className="flex items-center gap-1">
                    <button type="button" onClick={() => move(i, -1)} className="p-1.5 rounded-md hover:bg-muted" aria-label="Wyżej"><ArrowUp size={14} /></button>
                    <button type="button" onClick={() => move(i, 1)} className="p-1.5 rounded-md hover:bg-muted" aria-label="Niżej"><ArrowDown size={14} /></button>
                    <button type="button" data-testid={`comparison-row-remove-${i}`} onClick={() => set({ rows: cmp.rows.filter((_, j) => j !== i) })} className="p-1.5 rounded-md text-brand-red hover:bg-brand-red/10" aria-label="Usuń"><Trash2 size={14} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        type="button"
        data-testid="comparison-row-add"
        disabled={cmp.rows.length >= 25}
        onClick={() => set({ rows: [...cmp.rows, { label: "", values: {} }] })}
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-brand-teal hover:underline disabled:opacity-50"
      >
        <Plus size={14} /> Dodaj wiersz
      </button>
    </div>
  );
}
